import React, { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE




export default function AiAnimationRecords() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize] = useState(20)
  const [search, setSearch] = useState('')
  const [typeFilter, setTypeFilter] = useState('')
  const [detail, setDetail] = useState(null)

  useEffect(() => { loadData() }, [page])

  async function loadData() {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page, pageSize })
      if (search) params.set('search', search)
      if (typeFilter) params.set('type', typeFilter)
      const res = await fetch(`${API}/ai-videos/admin-list?${params.toString()}`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
      })
      if (res.ok) {
        const d = await res.json()
        if (d.success) {
          setRows(d.data.rows || [])
          setTotal(d.data.total || 0)
        }
      }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  async function handleDelete(id) {
    if (!window.confirm('确认删除这条记录吗？')) return
    try {
      const res = await fetch(`${API}/ai-videos/admin-delete/${id}`, {
        method: 'DELETE',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
      })
      const d = await res.json()
      if (d.success) {
        loadData()
      } else {
        alert('删除失败: ' + (d.error || '未知错误'))
      }
    } catch (e) { alert('删除失败') }
  }

  function handleSearch() { setPage(1); setTimeout(loadData, 0) }

  function formatCost(cost) {
    if (!cost || cost === 0) return '免费'
    return '\u00a5' + (cost / 100).toFixed(2)
  }

  function truncateId(id) {
    if (!id) return '\u2014'
    return id.length > 16 ? id.slice(0, 16) + '...' : id
  }

  const totalPages = Math.ceil(total / pageSize)

  if (detail) {
    return (
      <div style={{ padding: 24 }}>
        <button onClick={() => setDetail(null)} style={{
          background: 'none', border: 'none', color: '#1890ff', cursor: 'pointer',
          fontSize: 14, marginBottom: 16, padding: 0
        }}>{'\u2190'} 返回列表</button>
        <h2 style={{ marginBottom: 20 }}>{'\uD83C\uDFAC'} 视频详情</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
          <DetailCard label="ID" value={detail.id} />
          <DetailCard label="OpenID" value={detail.openid || '\u2014'} />
          <DetailCard label="状态" value={<Tag color={detail.status === 'succeeded' ? '#52c41a' : detail.status === 'running' ? '#1890ff' : detail.status === 'failed' ? '#ff4d4f' : '#faad14'}>{detail.status || '—'}</Tag>} />
          <DetailCard label="费用" value={formatCost(detail.cost)} />
          <DetailCard label="标题" value={detail.title || '\u2014'} />
          <DetailCard label="创建时间" value={detail.created_at || '\u2014'} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>Prompt</div>
          <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 12, whiteSpace: 'pre-wrap', fontSize: 13, maxHeight: 200, overflow: 'auto' }}>
            {detail.prompt || '\u2014'}
          </div>
        </div>
        {detail.video_url && (
          <div style={{ marginBottom: 20 }}>
            <div style={{ color: '#999', fontSize: 12, marginBottom: 8 }}>动画</div>
            <a href={detail.video_url} target="_blank" rel="noopener noreferrer" style={{
              display: 'inline-block', padding: '10px 20px', background: '#1890ff', color: '#fff',
              borderRadius: 6, textDecoration: 'none', fontSize: 14
            }}>{'\u25B6'} 在新窗口播放</a>
          </div>
        )}
        {detail.image_url && (
          <div>
            <div style={{ color: '#999', fontSize: 12, marginBottom: 8 }}>封面图</div>
            <img src={detail.image_url} alt="" style={{ maxWidth: 300, borderRadius: 8 }} />
          </div>
        )}
      </div>
    )
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: '0 0 4px', fontSize: 20 }}>{'\uD83C\uDFAC'} AI动画记录</h2>
          <p style={{ color: '#666', fontSize: 13, margin: 0 }}>管理所有AI动画（Seedance）生成记录</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <input
          placeholder="搜索 OpenID / 标题 / Prompt..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()}
          style={{ flex: 1, maxWidth: 320, padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }}
        />
        <select
          value={typeFilter}
          onChange={e => { setTypeFilter(e.target.value); setPage(1); setTimeout(loadData, 0) }}
          style={{ padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13, minWidth: 120 }}
        >
          <option value="">全部类型</option>
          <option value="ai">AI动画</option>
          <option value="story">绘本故事</option>
          <option value="ugc">UGC</option>
        </select>
        <button onClick={handleSearch} style={{
          padding: '8px 16px', background: '#1890ff', color: '#fff',
          border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13
        }}>搜索</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
        {[
          { label: '总记录数', value: total, color: '#1890ff' },
          { label: '已完成', value: rows.filter(r => r.status === 'succeeded').length, color: '#52c41a' },
          { label: '处理中', value: rows.filter(r => r.status === 'running').length, color: '#1890ff' },
          { label: '失败', value: rows.filter(r => r.status === 'failed').length, color: '#ff4d4f' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', borderRadius: 8, padding: '16px 20px', border: '1px solid #f0f0f0' }}>
            <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>{s.label}</div>
            <div style={{ fontSize: 28, fontWeight: 600, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading ? <p style={{ color: '#999', padding: 40, textAlign: 'center' }}>加载中...</p> : (
        <>
          <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
            <table style={tableStyle}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={th}>ID</th>
                  <th style={th}>用户ID</th>
                  <th style={th}>状态</th>
                  <th style={th}>标题</th>
                  <th style={th}>Prompt</th>
                  <th style={th}>费用</th>
                  <th style={th}>创建时间</th>
                  <th style={th}>操作</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(r => (
                  <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={td} title={r.id}>{truncateId(r.id)}</td>
                    <td style={td} title={r.openid}>{r.openid ? (r.openid.length > 20 ? r.openid.slice(0, 20) + '...' : r.openid) : '\u2014'}</td>
                    <td style={td}><Tag color={r.status === 'succeeded' ? '#52c41a' : r.status === 'running' ? '#1890ff' : r.status === 'failed' ? '#ff4d4f' : '#faad14'}>{r.status || '—'}</Tag></td>
                    <td style={{ ...td, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.title}>
                      {r.title || '\u2014'}
                    </td>
                    <td style={{ ...td, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.prompt}>
                      {r.prompt || '\u2014'}
                    </td>
                    <td style={{ ...td, fontWeight: 500, color: (r.cost && r.cost > 0) ? '#1890ff' : '#52c41a' }}>
                      {formatCost(r.cost)}
                    </td>
                    <td style={{ ...td, fontSize: 12, whiteSpace: 'nowrap' }}>{r.created_at ? r.created_at.slice(0, 19) : '\u2014'}</td>
                    <td style={td}>
                      {r.video_url && (
                        <a href={r.video_url} target="_blank" rel="noopener noreferrer" style={{
                          color: '#1890ff', textDecoration: 'none', marginRight: 8, fontSize: 12
                        }}>查看</a>
                      )}
                      <button onClick={() => setDetail(r)} style={{
                        background: 'none', border: 'none', color: '#722ed1', cursor: 'pointer', fontSize: 12, marginRight: 8, padding: 0
                      }}>详情</button>
                      <button onClick={() => handleDelete(r.id)} style={{
                        background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontSize: 12, padding: 0
                      }}>删除</button>
                    </td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr><td colSpan={8} style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无记录</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#999', fontSize: 13 }}>共 {total} 条记录</span>
            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1}
                style={pageBtnStyle(page <= 1)}>上一页</button>
              {Array.from({ length: Math.min(totalPages, 10) }, (_, i) => {
                let pageNum
                if (totalPages <= 10) {
                  pageNum = i + 1
                } else if (page <= 6) {
                  pageNum = i + 1
                } else if (page >= totalPages - 4) {
                  pageNum = totalPages - 9 + i
                } else {
                  pageNum = page - 5 + i
                }
                return (
                  <button key={pageNum} onClick={() => setPage(pageNum)}
                    style={{
                      minWidth: 32, height: 32, border: '1px solid ' + (page === pageNum ? '#1890ff' : '#d9d9d9'),
                      borderRadius: 4, background: page === pageNum ? '#1890ff' : '#fff',
                      color: page === pageNum ? '#fff' : '#333', cursor: 'pointer', fontSize: 12
                    }}>
                    {pageNum}
                  </button>
                )
              })}
              <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}
                style={pageBtnStyle(page >= totalPages)}>下一页</button>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

function Tag({ color, children }) {
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px', borderRadius: 10,
      fontSize: 11, background: color, color: '#fff', fontWeight: 500
    }}>{children}</span>
  )
}

function DetailCard({ label, value }) {
  return (
    <div style={{ background: '#fff', borderRadius: 8, padding: 12, border: '1px solid #f0f0f0' }}>
      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 13, wordBreak: 'break-all' }}>{value}</div>
    </div>
  )
}

const th = { padding: '10px 12px', fontSize: 12, color: '#666', textAlign: 'left', fontWeight: 500, whiteSpace: 'nowrap' }
const td = { padding: '10px 12px', fontSize: 13, color: '#333' }

const tableStyle = {
  width: '100%', borderCollapse: 'collapse', fontSize: 13
}

function pageBtnStyle(disabled) {
  return {
    padding: '4px 12px', border: '1px solid #d9d9d9', borderRadius: 4,
    background: disabled ? '#f5f5f5' : '#fff',
    color: disabled ? '#ccc' : '#333', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: 12
  }
}
